module.exports = __webpack_public_path__ + "assets/videos/intro/intro-3d-new/0047.jpg?v=fb493983";